module.exports = __webpack_public_path__ + "static/media/icon-open.d8758b5a.svg";